import { ErrorMessage, Field, Formik, Form } from 'formik';
import React, { useState } from 'react';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import {
  createActionSettingsSchema,
  extractParameters,
  getFieldInfoByName,
  validateItemIdBSLKey,
} from './Util';
import CustomLoader from '../../../common/CustomLoader';
import { validationForPdfToText } from '../../../../common/formElements/CollectionSectionType';
import { defaultFields } from 'drapcode-constant';
import BrowserStorageLocationField from '../BrowserStorageLocationField';
import {
  SEND_ITEM_ID_FROM_OPTIONS_DESC,
  sendItemIdFromOptions,
} from '../../../../common/utils/event_constants';
export const PdfToTextForm = ({
  projectId,
  selectedEvent,
  eventAction,
  actionData,
  events,
  actions,
  hideModal,
  showLoaderForAction,
  version,
}) => {
  const [selectedCollection, setSelectedCollection] = useState(null);

  const renderSendItemIdFrom = (action, setFieldValue, setFieldTouched, values) => {
    // Fallback handling of Checkbox field values in the Dropdown
    if (!values['sendItemIdFrom']) {
      if (values['sendCurrentObjectID']) {
        values['sendItemIdFrom'] = 'sendCurrentObjectID';
        values['sendCurrentObjectID'] = '';
      } else if (values['sendCurrentPageItemId']) {
        values['sendItemIdFrom'] = 'sendCurrentPageItemId';
        values['sendCurrentPageItemId'] = '';
        // } else if (values['sendCurrentPageReferenceItemId']) {
        //   values['sendItemIdFrom'] = 'sendCurrentPageReferenceItemId';
        //   values['sendCurrentPageReferenceItemId'] = '';
      } else if (values['sendCurrentUserId']) {
        values['sendItemIdFrom'] = 'sendCurrentUserId';
        values['sendCurrentUserId'] = '';
      } else if (values['sendPreviousStepParentCollectionId']) {
        values['sendItemIdFrom'] = 'sendPreviousStepParentCollectionId';
        values['sendPreviousStepParentCollectionId'] = '';
      } else if (values['sendTargetItemID']) {
        values['sendItemIdFrom'] = 'sendTargetItemID';
        values['sendTargetItemID'] = '';
      }
    }

    return (
      <div className="form-group">
        <FormFieldWithLabel
          cta={false}
          label="Get Item ID From"
          icon="select"
          infoIcon={true}
          infoDescription={SEND_ITEM_ID_FROM_OPTIONS_DESC}
        >
          <CustomSelect
            name={'sendItemIdFrom'}
            isMulti={false}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            options={sendItemIdFromOptions()}
            value={values['sendItemIdFrom']}
          />
          <ErrorMessage name={'sendItemIdFrom'}>
            {(msg) => <p className="text-error">{msg}</p>}
          </ErrorMessage>
        </FormFieldWithLabel>
      </div>
    );
  };

  const isSendBSLItemIdEnabled = (values) => {
    return values['sendItemIdFrom'] === 'sendBSLItemId';
  };

  const collectionOptions = () => {
    let options = [{ value: '', label: 'Choose Collection' }];
    let collections = events ? events.collections : [];
    if (collections.length > 0) {
      options = options.concat(
        collections.map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };

  const fieldPdfOptions = (Values) => {
    let options = [{ value: '', label: 'Choose File' }];
    let collections = events ? events.collections : [];
    const findCollection = (collectionName) =>
      collections.find((obj) => obj.collectionName === collectionName);
    const foundCollection = findCollection(Values.collection);
    if (foundCollection && foundCollection.fields) {
      setSelectedCollection(foundCollection);
      foundCollection.fields.forEach((field) => {
        const lowercaseFieldName = field.fieldName.toLowerCase();
        if (!defaultFields.includes(lowercaseFieldName) && lowercaseFieldName !== 'createdby') {
          options.push({ value: field.fieldName, label: field.fieldTitle.en });
        }
      });
    }
    return options;
  };
  const fieldTextOptions = (Values) => {
    let options = [{ value: '', label: 'Choose Text Field' }];
    if (selectedCollection && selectedCollection.fields) {
      selectedCollection.fields.forEach((field) => {
        const lowercaseFieldName = field.fieldName.toLowerCase();
        if (
          !defaultFields.includes(lowercaseFieldName) &&
          field.fieldName !== Values.fieldForPdf &&
          lowercaseFieldName !== 'createdby'
        ) {
          options.push({ value: field.fieldName, label: field.fieldTitle.en });
        }
      });
    }
    return options;
  };

  const handleSubmit = (values) => {
    let parameters = extractParameters(values, actionData);
    let actionFormData = eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    hideModal();
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={createActionSettingsSchema(actionData, eventAction)}
      validationSchema={validationForPdfToText()}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, setFieldTouched }) => (
        <Form>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Choose Collection"
                  icon="select"
                  infoIcon={true}
                  infoDescription="Select Collection which you want to Create Item For."
                >
                  <CustomSelect
                    name={'collection'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={collectionOptions()}
                    value={values['collection']}
                  />
                </FormFieldWithLabel>
                <ErrorMessage name={'collection'}>
                  {(msg) => <p className="text-error ml-5">{msg}</p>}
                </ErrorMessage>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Select file source field"
                  icon="select"
                  infoIcon={true}
                  infoDescription="Select file source field where your file exists."
                >
                  <CustomSelect
                    name={'fieldForPdf'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={fieldPdfOptions(values)}
                    value={values['fieldForPdf']}
                  />
                </FormFieldWithLabel>
                <ErrorMessage name={'fieldForPdf'}>
                  {(msg) => <p className="text-error ml-5">{msg}</p>}
                </ErrorMessage>
              </div>
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Select Text destination field"
                  icon="select"
                  infoIcon={true}
                  infoDescription={'Select Text field in which you want to save your PDF text.'}
                >
                  <CustomSelect
                    name={'fieldForText'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={fieldTextOptions(values)}
                    value={values['fieldForText']}
                  />
                </FormFieldWithLabel>
                <ErrorMessage name={'fieldForText'}>
                  {(msg) => <p className="text-error ml-5">{msg}</p>}
                </ErrorMessage>
              </div>
            </div>
            <div className="col-12">
              {renderSendItemIdFrom(actionData, setFieldValue, setFieldTouched, values)}
              {isSendBSLItemIdEnabled(values) && (
                <>
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Item Collection"
                      icon="select"
                      infoIcon={true}
                      infoDescription={'Item Collection'}
                    >
                      <CustomSelect
                        name={'bslCollection'}
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={collectionOptions()}
                        value={values['bslCollection']}
                      />
                      <ErrorMessage name={'bslCollection'}>
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </FormFieldWithLabel>
                  </div>
                  {values['bslCollection'] && (
                    <>
                      <BrowserStorageLocationField
                        fieldName={'browserStorageLocation'}
                        values={values}
                        description={
                          'Select a browser storage location to get an Item ID key (Default: Session Storage).'
                        }
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                      />
                      <div className="form-group">
                        <FormFieldWithLabel
                          cta={false}
                          label="Item ID JSON Key"
                          icon="text"
                          infoIcon={true}
                          infoDescription={`Enter the key which contains Item ID value in your web browser storage.`}
                        >
                          <Field
                            type="text"
                            name="itemIdBSLKey"
                            className="form-control form-control-sm"
                            autoComplete="off"
                            placeholder="Item ID JSON Key Eg. Key1 or, Parent_Key1.Child_Key[0]"
                            validate={validateItemIdBSLKey}
                          />
                        </FormFieldWithLabel>
                        <ErrorMessage name={'itemIdBSLKey'}>
                          {(msg) => <p className="text-error ml-5">{msg}</p>}
                        </ErrorMessage>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Success Message"
                  icon="text"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('successMessage')}
                >
                  <Field
                    name="successMessage"
                    type="text"
                    placeholder="(Optional) Enter custom success message."
                    className="form-control form-control-sm"
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Error Message"
                  icon="text"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('errorMessage')}
                >
                  <Field
                    name="errorMessage"
                    type="text"
                    placeholder="(Optional) Enter custom error message."
                    className="form-control form-control-sm"
                  />
                </FormFieldWithLabel>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-left">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={hideModal}
              >
                <span>
                  <i className="wb webconnect-times"></i>&nbsp;Cancel
                </span>
              </button>
            </div>
            <div className="col-md-6 text-right">
              <button type="submit" className="btn btn-theme-submit btn-sm">
                <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                <CustomLoader loading={showLoaderForAction} />
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
